import { getCancellationPolicyOption } from "../../../constants/cancellationPolicy";
import SectionHead, { renderLines, sectionText, toParagraphs } from "./SectionHead";

// Policies on a Custom page: the pro's cancellation policy, in the same words
// clients read when they book, in a card first, then whatever else they wrote.
// Either can be missing; with neither there's no section.

const CalendarCancelIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.25"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <rect width="18" height="18" x="3" y="4" rx="3" />
    <path d="M16 2v4" />
    <path d="M8 2v4" />
    <path d="M3 10h18" />
    <path d="m14 14-4 4" />
    <path d="m10 14 4 4" />
  </svg>
);

const ProfilePoliciesSection = ({ sectionId = "policies", content, cancellationPolicy }) => {
  const heading = sectionText(content?.heading) || "Policies";
  const paragraphs = toParagraphs(content?.body);
  const cancellation = sectionText(cancellationPolicy)
    ? getCancellationPolicyOption(cancellationPolicy)
    : null;

  if (!cancellation && paragraphs.length === 0) return null;

  const headingId = `profile-section-${sectionId}-heading`;
  return (
    <section className="profile-block profile-policies" aria-labelledby={headingId}>
      <SectionHead id={headingId} heading={heading} />
      {cancellation && (
        <div className="profile-block__card profile-policies__rule">
          <span className="profile-policies__icon">
            <CalendarCancelIcon />
          </span>
          <div className="profile-policies__rule-text">
            <p className="profile-policies__rule-title">Cancellation</p>
            <p className="profile-policies__rule-body">{cancellation.description}</p>
          </div>
        </div>
      )}
      {paragraphs.length > 0 && (
        <div className="profile-policies__text">
          {paragraphs.map((paragraph, index) => (
            <p key={index}>{renderLines(paragraph)}</p>
          ))}
        </div>
      )}
    </section>
  );
};

export default ProfilePoliciesSection;
